import { render, staticRenderFns } from "./IndividualItems.vue?vue&type=template&id=213ec862&scoped=true"
import script from "./IndividualItems.vue?vue&type=script&lang=js"
export * from "./IndividualItems.vue?vue&type=script&lang=js"
import style0 from "./IndividualItems.vue?vue&type=style&index=0&id=213ec862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ec862",
  null
  
)

export default component.exports